import React from 'react';
import DownloadManual from './DownloadManual';
class UnauthenticatedHeader extends React.Component {
  
    render() {
        return (
            <div style={{ display: "flow-root" }}>
                <DownloadManual />
            </div>
        )
    }
}
export default UnauthenticatedHeader;